 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"canvg":"canvg","common":"common","modules-administracion-presupuesto-administracion-presupuesto-module":"modules-administracion-presupuesto-administracion-presupuesto-module","modules-informe-clientes-nuevos-informe-clientes-nuevos-module":"modules-informe-clientes-nuevos-informe-clientes-nuevos-module","modules-informe-ventas-detalle-informe-ventas-detalle-module":"modules-informe-ventas-detalle-informe-ventas-detalle-module","modules-informe-ventas-grupo-marca-linea-informe-ventas-grupo-marca-linea-module":"modules-informe-ventas-grupo-marca-linea-informe-ventas-grupo-marca-linea-module","modules-informe-ventas-producto-informe-ventas-producto-module":"modules-informe-ventas-producto-informe-ventas-producto-module","modules-pedido-web-pedido-web-module":"modules-pedido-web-pedido-web-module","modules-precios-precios-module":"modules-precios-precios-module","modules-usuarios-usuarios-module":"modules-usuarios-usuarios-module","default~modules-administracion-cargue-picking-administracion-cargue-picking-module~modules-administr~54f37cf4":"default~modules-administracion-cargue-picking-administracion-cargue-picking-module~modules-administr~54f37cf4","modules-administracion-entr-tpovehiculo-administracion-entr-tpovehiculo-module":"modules-administracion-entr-tpovehiculo-administracion-entr-tpovehiculo-module","default~modules-administracion-cargue-picking-administracion-cargue-picking-module~modules-autorizac~2d62cc25":"default~modules-administracion-cargue-picking-administracion-cargue-picking-module~modules-autorizac~2d62cc25","modules-autorizacion-pedidos-autorizacion-pedidos-module":"modules-autorizacion-pedidos-autorizacion-pedidos-module","modules-informe-gestion-vendedor-cartera-informe-gestion-vendedor-cartera-module":"modules-informe-gestion-vendedor-cartera-informe-gestion-vendedor-cartera-module","modules-informe-gestion-vendedor-informe-gestion-vendedor-module":"modules-informe-gestion-vendedor-informe-gestion-vendedor-module","modules-picking-picking-module":"modules-picking-picking-module","modules-administracion-cargue-picking-administracion-cargue-picking-module":"modules-administracion-cargue-picking-administracion-cargue-picking-module","default~modules-administracion-menu-web-administracion-menu-web-module~modules-encuestas-fijas-encue~101521ad":"default~modules-administracion-menu-web-administracion-menu-web-module~modules-encuestas-fijas-encue~101521ad","modules-administracion-menu-web-administracion-menu-web-module":"modules-administracion-menu-web-administracion-menu-web-module","modules-encuestas-fijas-encuestas-fijas-module":"modules-encuestas-fijas-encuestas-fijas-module","default~modules-gestion-maestras-gestion-maestras-module~modules-productos-productos-module":"default~modules-gestion-maestras-gestion-maestras-module~modules-productos-productos-module","modules-productos-productos-module":"modules-productos-productos-module","modules-gestion-maestras-gestion-maestras-module":"modules-gestion-maestras-gestion-maestras-module","default~modules-informe-novedades-vendedor-informe-novedades-vendedor-module~modules-inicio-inicio-module":"default~modules-informe-novedades-vendedor-informe-novedades-vendedor-module~modules-inicio-inicio-module","modules-informe-novedades-vendedor-informe-novedades-vendedor-module":"modules-informe-novedades-vendedor-informe-novedades-vendedor-module","modules-inicio-inicio-module":"modules-inicio-inicio-module","dompurify":"dompurify","html2canvas":"html2canvas","juggle-resize-observer":"juggle-resize-observer","modules-administracion-correos-administracion-correos-module":"modules-administracion-correos-administracion-correos-module","modules-agencia-agencia-module":"modules-agencia-agencia-module","modules-generacion-archivos-generacion-archivos-module":"modules-generacion-archivos-generacion-archivos-module","modules-informe-gestion-b2c-informe-gestion-b2c-module":"modules-informe-gestion-b2c-informe-gestion-b2c-module","modules-informe-productos-informe-productos-module":"modules-informe-productos-informe-productos-module","modules-informe-venta-efectiva-informe-venta-efectiva-module":"modules-informe-venta-efectiva-informe-venta-efectiva-module","modules-jerarquias-jerarquias-module":"modules-jerarquias-jerarquias-module","modules-reporte-entregas-reporte-entregas-module":"modules-reporte-entregas-reporte-entregas-module","modules-rutero-rutero-module":"modules-rutero-rutero-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
